import React, { useEffect } from "react";
import { DashboardCard } from "./DashboardCards/DashboardCard";
import { Box } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { getProducts } from "../../../Store/Features/Product/productSlice";
import { useNavigate } from "react-router-dom";
import { getOrders } from "../../../Store/Features/Order/orderSlice";
import CircularProgress from "@mui/material/CircularProgress";
export const Dashboard = () => {
  const dispatch = useDispatch();
  const { slug } = useParams();

  const Products = useSelector((state) => state.productsSlice.value);
  const Orders = useSelector((state) => state.ordersSlice.value);
  const Loading = useSelector((state) => state.productsSlice.loading);
  const Loading1 = useSelector((state) => state.ordersSlice.loading);
  function isObjEmpty(obj) {
    return Object.keys(obj).length === 0;
  }

  useEffect(() => {
    if (isObjEmpty(Orders)) {
      dispatch(getOrders(slug));
    }
  }, []);
  useEffect(() => {
    if (isObjEmpty(Products)) {
      dispatch(getProducts(slug));
    }
  }, []);
  return (
    <Box className="ContainserDetail2">
      {Loading1 ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            justifyContent: "center",
            height: "40vh",
            width: "100%",
          }}
        >
          <CircularProgress />
        </Box>
      ) : (
        <>
          <DashboardCard Title={"Total Product"} Total={Products?.length} To={`/Channel/${slug}/Product`} />
          <DashboardCard Title={"Total Orders"} Total={Orders?.length} To={`/Channel/${slug}/Product`} />
        </>
      )}
    </Box>
  );
};
